<app-produto-modal [isOpen]="isProdutoModalOpen" (closeModal)="closeProdutoModal($event)"></app-produto-modal>
<app-cliente-modal [isOpen]="isClienteModalOpen" (closeModal)="closeClienteModal($event)"></app-cliente-modal>
<app-servicos-modal [isOpen]="isServicoModalOpen" (closeModal)="closeServicoModal($event)"></app-servicos-modal>
<app-comentario-modal
  [isOpen]="isComentarioModalOpen"
  [title]="'Comentario do grupo'"
  [initialMap]="comentarioMapaAtual"
  (cancelled)="fecharComentarioModal()"
  (saved)="adicionarComentarioGrupo($event)">
</app-comentario-modal>

<app-confirm-dialog
  [isOpen]="isConfirmConverterVendaOpen"
  title="Converter em venda"
  message="Orçamento salvo com sucesso! Deseja converter este orçamento em venda agora?"
  confirmLabel="Sim, converter"
  cancelLabel="Não, voltar"
  [closeOnBackdrop]="false"
  (confirmed)="confirmarConverterEmVenda()"
  (cancelled)="recusarConverterEmVenda()">
</app-confirm-dialog>

<app-venda-modal-v2
  *ngIf="orcamentoParaVenda"
  [isOpen]="isVendaModalOpen"
  [orcamento]="orcamentoParaVenda"
  [tipoAcao]="'NOVA_VENDA'"
  [clienteComRestricao]="clienteRestricaoAtiva"
  (closeModal)="fecharVendaModal()">
</app-venda-modal-v2>

<section class="orcamento-it-shell">
  <header class="orcamento-it-hero">
    <div>
      <h2 class="orcamento-it-title">Detalhes do Orçamento</h2>
      <p class="orcamento-it-subtitle">Gerencie os itens e condições do orçamento.</p>
    </div>
    <span class="orcamento-it-chip">Orçamento</span>
  </header>

  <div *ngIf="isSomenteVisualizacao" class="alert alert-info" role="alert">
    Este orçamento está CONCLUIDO e disponível apenas para visualização.
  </div>

  <div class="orcamento-it-card">
    <div [formGroup]="orcamentoForm" class="container-fluid p-3">
      <div class="row g-3">
        <div class="col-md-1">
          <label for="id" class="form-label fw-bold">ID</label>
          <input type="text" id="id" class="form-control bg-light" formControlName="id" readonly>
        </div>

        <div class="col-md-4" formGroupName="cliente">
          <label for="nomeCliente" class="form-label fw-bold">Cliente</label>
          <div class="input-group">
            <input type="text" id="nomeCliente" class="form-control"
                   formControlName="nomeRazaoSocial" placeholder="Selecione um cliente"
                   [style.pointer-events]="true ? 'none' : 'auto'"
                  [style.background-color]="true ? '#e9ecef' : '#fff'"
                   [ngClass]="{ 'is-invalid': orcamentoForm.get('cliente.nomeRazaoSocial')?.invalid && orcamentoForm.get('cliente.nomeRazaoSocial')?.touched }" readOnly>

                   <button class="btn btn-outline-secondary" type="button" (click)="incluirCliente()" [disabled]="isSomenteVisualizacao">
              <i class="bi bi-search"></i> Buscar
            </button>
            <div *ngIf="orcamentoForm.get('cliente.nomeRazaoSocial')?.invalid && orcamentoForm.get('cliente.nomeRazaoSocial')?.touched" class="invalid-feedback">
                Cliente é obrigatório.
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <label for="status" class="form-label fw-bold">Status</label>
          <select id="status" class="form-select" formControlName="statusOrcamento" [disabled]="isSomenteVisualizacao"
                  [ngClass]="{ 'is-invalid': orcamentoForm.get('statusOrcamento')?.invalid && orcamentoForm.get('statusOrcamento')?.touched }">
            <option value="ABERTO">ABERTO</option>
            <option value="FECHADO">FECHADO</option>
            <option value="CONCLUIDO">CONCLUIDO</option>
            <option value="CANCELADO">CANCELADO</option>
          </select>
          <div *ngIf="orcamentoForm.get('statusOrcamento')?.invalid && orcamentoForm.get('statusOrcamento')?.touched" class="invalid-feedback">
              Status é obrigatório.
          </div>
        </div>

        <div class="col-md-2">
          <label for="dataOrcamento" class="form-label fw-bold">Data</label>
          <input type="date" id="dataOrcamento" class="form-control" formControlName="dataOrcamento" [readonly]="isSomenteVisualizacao"
                 [ngClass]="{ 'is-invalid': orcamentoForm.get('dataOrcamento')?.invalid && orcamentoForm.get('dataOrcamento')?.touched }">
          <div *ngIf="orcamentoForm.get('dataOrcamento')?.invalid && orcamentoForm.get('dataOrcamento')?.touched" class="invalid-feedback">
              Data do orçamento é obrigatória.
          </div>
        </div>

        <div class="col-md-3">
          <label for="validadeOrcamento" class="form-label fw-bold">Validade</label>
          <input type="date" id="validadeOrcamento" class="form-control" formControlName="validadeOrcamento" [readonly]="isSomenteVisualizacao"
                 [ngClass]="{ 'is-invalid': orcamentoForm.get('validadeOrcamento')?.invalid && orcamentoForm.get('validadeOrcamento')?.touched }">
          <div *ngIf="orcamentoForm.get('validadeOrcamento')?.invalid && orcamentoForm.get('validadeOrcamento')?.touched" class="invalid-feedback">
              Data de validade é obrigatória.
          </div>
        </div>

        <div class="col-md-2">
          <label for="custoInstalacao" class="form-label fw-bold">Custo Instalação</label>
          <div class="input-group">
            <span class="input-group-text">R$</span>
            <input type="number" id="custoInstalacao" class="form-control"
               formControlName="custoInstalacao" (input)="calcularInstalacao()" step="0.01" [readonly]="isSomenteVisualizacao">
          </div>
        </div>

        <div class="col-md-2">
          <label for="descontoAplicado" class="form-label fw-bold">Desconto Extra</label>
          <div class="input-group">
            <span class="input-group-text">R$</span>
            <input type="text" id="descontoAplicado" class="form-control"
                   formControlName="descontoAplicado"
                   inputmode="decimal"
                   (input)="calcularDescontoTotal()"
                   (blur)="formatarDescontoExtra()"
                   [readonly]="isSomenteVisualizacao">
          </div>
        </div>

        <div class="col-md-10">
          <label for="observacao" class="form-label fw-bold">Observações</label>
          <textarea id="observacao" class="form-control" formControlName="observacao" rows="2" [readonly]="isSomenteVisualizacao"></textarea>
        </div>
      </div>
    </div>
  </div>

  <!-- Bloco de Botões de Ação -->
  <div class="d-flex justify-content-center my-4" *ngIf="!isSomenteVisualizacao">
    <button class="btn btn-info me-3" (click)="incluirProduto()">Incluir Produto</button>
    <button class="btn btn-info" (click)="incluirServico()">Incluir Serviço</button>
  </div>

  <!-- Bloco da Lista de Itens -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3>Itens do Orçamento</h3>
  </div>
  <hr />

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="text-start">Grupo</th>
          <th scope="col">Produto/Serviço</th>
          <th scope="col" class="text-start">Quantidade</th>
          <th scope="col" class="text-center">Preço Unitário</th>
          <th scope="col" class="text-center">Subtotal</th>
          <th scope="col" class="text-start">Desconto</th>
          <th scope="col" class="text-start">Acréscimo</th>
          <th scope="col" class="text-center">Valor Total</th>
          <th scope="col" class="text-center">Comentário</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of itensTemporarios; let i = index">

          <td style="width: 80px;">
            <input type="number" class="form-control form-control-sm text-center" [(ngModel)]="item.grupo" [disabled]="isSomenteVisualizacao">
          </td>

          <td class="text-truncate" style="max-width: 200px;">
            {{ item.nomeItem }}
          </td>

          <td style="width: 100px;">
            <input type="number" class="form-control form-control-sm text-center"
                     [(ngModel)]="item.qtdItem" (input)="calcularSubTotal(item)" [disabled]="isSomenteVisualizacao">
          </td>

          <td class="text-truncate text-center" style="max-width: 250px;">
            {{ item.valorItem | currency:'BRL' }}
          </td>

          <td style="width: 130px;" class="fw-medium text-center">
            {{ item.subtotal | currency:'BRL' }}
          </td>

          <td style="width: 110px;"><!-- TODO PARAMETRIZAR O MAXIMO DE DESCONTO-->
            <input type="number" class="form-control form-control-sm text-end"
                   [(ngModel)]="item.desconto" (input)="calcularNovoTotal(item)"
                   min="0"
                   max="100"
                oninput="this.value = Math.abs(this.value)" [disabled]="isSomenteVisualizacao">
          </td>

          <td style="width: 110px;">
            <input type="number" class="form-control form-control-sm text-end"
                   [(ngModel)]="item.acrescimo" (input)="calcularNovoTotal(item)"
                   min="0"
                   max="100"
                oninput="this.value = Math.abs(this.value)" [disabled]="isSomenteVisualizacao">
          </td>

          <td style="width: 130px;" class="text-center fw-bold text-primary">
            {{ item.total | currency:'BRL' }}
          </td>

          <td style="width: 100px;" class="text-center">
            <button class="btn btn-link btn-sm p-0"
              [ngClass]="hasComentario(item) ? 'text-success' : 'text-danger'"
              (click)="incluirComentario(i)"
              *ngIf="!isSomenteVisualizacao">
              <i class="bi bi-pencil"></i> Extra
            </button>
          </td>

          <td style="width: 100px;" class="text-center">
            <button class="btn btn-link text-danger btn-sm p-0" (click)="removerItem(i)" *ngIf="!isSomenteVisualizacao">
              <i class="bi bi-trash"></i> Remover
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row justify-content-end mt-4">
    <div class="col-md-4 col-lg-3">

      <div class="card bg-light border-0 shadow-sm">
        <div class="card-body p-4">
          <h5 class="card-title fw-bold mb-4 text-uppercase text-secondary" style="font-size: 0.85rem;">
            Resumo do Orçamento
          </h5>

          <div class="d-flex justify-content-between mb-2">
            <span class="text-muted">Subtotal:</span>
            <span class="fw-medium">{{ valorSubtotalOrcamento | currency:'BRL' }}</span>
          </div>

          <div class="d-flex justify-content-between mb-2 text-danger">
            <span>Desconto Itens:</span>
            <span>- {{ valorDescontoOrcamento | currency:'BRL' }}</span>
          </div>

          <div class="d-flex justify-content-between mb-3 text-success">
            <span>Acréscimo:</span>
            <span>+ {{ valorAcrescimoOrcamento | currency:'BRL' }}</span>
          </div>

          <div class="d-flex justify-content-between mb-3 text-success">
            <span>Instalação:</span>
            <span>+ {{ valorCustoInstalacao | currency:'BRL' }}</span>
          </div>

          <div class="d-flex justify-content-between mb-3 text-danger">
            <span>Desconto Total:</span>
            <span>- {{ valorDescontoExtra | currency:'BRL' }}</span>
          </div>

          <hr class="my-3">

          <div class="d-flex justify-content-between align-items-center">
            <span class="h5 mb-0 fw-bold">Total:</span>
            <span class="h4 mb-0 fw-bold text-primary">
              {{ valorTotalOrcamento | currency:'BRL' }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <button class="btn btn-outline-secondary px-4" (click)="cancelar()">
          <i class="bi bi-x-circle me-1"></i> Cancelar
        </button>
        <button *ngIf="!isSomenteVisualizacao" class="btn btn-primary px-4 shadow-sm" data-testid="btn-salvar-orcamento" (click)="salvar()" [disabled]="orcamentoForm.invalid">
          <i class="bi bi-check2-circle me-1"></i> Salvar Orçamento
        </button>
      </div>

    </div>
  </div>
</section>
